module.exports = __webpack_public_path__ + "static/media/phone.3d90953.mp3";


//////////////////
// WEBPACK FOOTER
// ./static/audio/phone.mp3
// module id = 8Zvq
// module chunks = 1